import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import { useClickOutside } from '../../hooks/useClickOutside';

const UserDropdown = ({ userInfo, assessmentsRemaining, monthlyLimit, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);

  useClickOutside(() => setIsOpen(false), isOpen, 'user-dropdown');

  return (
    <div className="relative user-dropdown">
      {/* User Avatar Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-3 hover:bg-teal-600 rounded-lg p-2 transition-colors"
      >
        <div className="text-right">
          <div className="text-sm text-white">{userInfo?.email}</div>
          <div className="text-xs text-teal-200">
            {assessmentsRemaining !== null ? `${assessmentsRemaining} credits` : 'Loading...'}
          </div>
        </div>
        <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center">
          <span className="text-sm font-semibold text-white">
            {userInfo?.email?.charAt(0).toUpperCase()}
          </span>
        </div>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
          {/* User Info */}
          <div className="px-4 py-3 border-b border-gray-100">
            <div className="text-sm font-medium text-gray-900">{userInfo?.email}</div>
            <div className="text-xs text-gray-500">CliniScore User</div>
          </div>

          {/* Credits Info */}
          <div className="px-4 py-3 border-b border-gray-100">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-700">Remaining Credits</span>
              <span className={`text-lg font-bold ${assessmentsRemaining !== null && assessmentsRemaining <= 2 ? 'text-amber-600' : 'text-teal-600'}`}>
                {assessmentsRemaining !== null ? assessmentsRemaining : '...'}
              </span>
            </div>
            <div className="text-xs text-gray-500 mt-1">
              Monthly limit: {monthlyLimit} + bonus credits
            </div>
          </div>

          {/* Logout Button */}
          <button
            onClick={() => {
              setIsOpen(false);
              onLogout();
            }}
            className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
          >
            <LogOut size={14} />
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;

